import breakpoints from './breakpoints.module.css';
import { BASE_TOKENS } from './tokenValues';

export { baseCssVars, themeBackground, themeCssVars, withAlpha } from './tokenValues';

// Брейкпоинты имеют один источник для @value в CSS и расчётов sizes в TypeScript.
export const tokens = { ...BASE_TOKENS, breakpoints } as const;
